import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import { langSelector } from '../store/langSlice';

export default function CustomInput({
  type,
  placeholder,
  limit=false,
  messagePlusLimirWord,
  value,
  setValue,
  isError=false,
  isArabicStyle=true,
  error
}) {
  const [wordCount, setWordCount] = useState(0);
  const lang = useSelector(langSelector);

  const getInput = () => {
    if (type === 'textarea') {
      const limitWord = 500;
      return (
        <>
          <textarea
            style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}
            className={`w-full font-inter font-medium text-2xl sm:text-3xl px-5 py-4 ${isError ? 'mb-0' : 'mb-5'} rounded-[20px] border-2 focus:outline-none focus:border-primary ${isError ? 'border-primary' : 'border-gray'}`}
            placeholder={placeholder}
            rows={8}
            value={value}
            onPaste={(e) => {
              if (limit) {
                const pastedText = e.clipboardData.getData('Text');
                const wordCount = pastedText.trim().split(/\s+/).length;
          
                if (wordCount > limitWord) {
                  e.preventDefault();
                  alert(messagePlusLimirWord);
                }
              }
            }}
            onChange={(e) => {
              if (limit) {
                const inputText = e.target.value;
                const count = inputText.trim() === '' ? 0 : inputText.trim().split(/\s+/).length;
                setWordCount(count);
            
                if (wordCount <= limitWord) {
                  setValue(inputText);
                }
              } else {
                setValue(e.target.value);
              }
            }}
          ></textarea>
          <p className={`${!limit && 'hidden'} text-end relative ${isError ? 'bottom-0' : 'bottom-5'} text-xl font-medium ${wordCount > limitWord && 'text-primary'}`} style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>{wordCount} / {limitWord}</p>
        </>
      )
    }
    return (
      <input
        type={type}
        min={1}
        placeholder={placeholder}
        className={`w-full font-inter font-medium text-2xl sm:text-3xl px-5 py-4 ${isError ? 'mb-0' : 'mb-5'} rounded-[20px] border-2 focus:outline-none focus:border-primary ${isError ? 'border-primary' : 'border-gray'}`}
        style={isArabicStyle ? {transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'} : {}}
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
    );
  }

  return (
    <div>
      {getInput()}
      <p className={`relative ${type === 'textarea' && 'bottom-1.5'} mb-5 pl-5 font-medium text-xl text-primary ${isError ? 'block' : 'hidden'}`} style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>{error}</p>
    </div>
  )
}
